import type { GenerateTermsRequest } from '@/api/generated/schemas';
import { TermGenerationMode, TermRecurrenceMode, TermSpanMode } from '@/api/generated/schemas';

/**
 * Sestaví tělo `GenerateTermsRequest` pro založení termínů z kalendáře —
 * vždy režim Calendar s explicitními začátky; pole rekurence jsou jen povinné výplně kontraktu.
 */
export function toCalendarGenerateRequest(calendarStarts: readonly string[]): GenerateTermsRequest {
  return {
    mode: TermGenerationMode.Calendar,
    span: TermSpanMode.IncludeEnds,
    recurrence: TermRecurrenceMode.Days,
    from: null,
    to: null,
    everyDays: 1,
    everyWeeks: 1,
    daysOfWeek: [],
    calendarStarts: [...calendarStarts],
    nightsOverride: null,
    confirmedCount: calendarStarts.length,
  } satisfies GenerateTermsRequest;
}
